<app-loader [isLoading]="isLoading"></app-loader>

<!-- <div class="header">
  <app-title [title]="title" [subtitle]="subtitle"></app-title>
</div> -->

<div class="header">
  <div class="top">
    <a routerLink="/home/dining/general" [queryParams]="{tab: 'consumos'}">
      <h3>Consumos /</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ subtitle }}</h2>
      </div>
    </a>
  </div>
</div>

<div class="content">
  <app-restaurant-filter-bar [config]="filterBarConfig" [selectedFilter]="selectedFilter" [startDate]="startDate"
    [endDate]="endDate" (filterChange)="onFilterChange($event)" (dateRangeChange)="onDateRangeChange($event)"
    (exportClick)="onExportClick()" (backClick)="onBackClick()"></app-restaurant-filter-bar>

  <div style="padding-left: 40px; margin-bottom: 16px">
    <app-export-excel-button text="Exportar Excel" (exportClick)="onExportClick()">
    </app-export-excel-button>
  </div>

  <app-restaurant-summary-cards [cards]="summaryCards" layout="grid"></app-restaurant-summary-cards>

  <div class="switch" [class.active]="isActive" [class.inactive]="!isActive">
    <span>COBRAR TODO</span>
    <mat-slide-toggle [checked]="isActive" (change)="isActive = $event.checked; toggleBulkCharge()"></mat-slide-toggle>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8 table">
    <!-- Columna de Fecha -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>FECHA</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          element.date | date : "dd/MM/yyyy"
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de Precio -->
    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>PRECIO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px" class="utility-button">{{ element.price }}€</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="price_company">
      <th mat-header-cell *matHeaderCellDef>PRECIO EMPRESA</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px" class="utility-button">{{ element.price_company }}€</span>
      </td>
    </ng-container>

    <!-- Columna de Tipo de Consumo -->
    <ng-container matColumnDef="punch_type_display">
      <th mat-header-cell *matHeaderCellDef>TIPO</th>
      <td mat-cell *matCellDef="let element">
        @if (element.punch_type_display === 'Almuerzo') {
        <span style="font-size: 16px" class="utility-button">Comida</span>
        }@else {
        <span style="font-size: 16px" class="utility-button">{{
          element.punch_type_display
          }}</span>

        }
      </td>
    </ng-container>

    <!-- Columna de Estado -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>ESTADO</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button" [ngClass]="{
            'status-eaten': element.status === 'eaten',
            'status-pending': element.status === 'pending'
          }">
          <span style="font-size: 16px">{{
            getStatusDisplay(element.status)
            }}</span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>Tipo</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{
          getSourceDisplay(element)
          }}</span>
      </td>
    </ng-container>

    <!-- Columna de Cobrar -->
    <ng-container matColumnDef="charge">
      <th mat-header-cell *matHeaderCellDef>COBRAR</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle [checked]="element.charge" (change)="toggleChargeStatus(element, $event.checked)"
          [disabled]="isUpdatingCharge(element)" class="charge-toggle">
        </mat-slide-toggle>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'pending-status': row.status === 'PENDING' }"></tr>
  </table>
</div>